module.exports = __webpack_public_path__ + "img/edit.9bbab19e.svg";